import React, { createContext, useContext } from 'react';
import { PickerDay, PickerDayProps } from '@mui/x-date-pickers/PickerDay';

export const SeedingCalendarRangeContext = createContext<(date: Date) => boolean>(() => false);

export default function SeedingCalendarDay(props: PickerDayProps) {
  const isDateInSelectedCropRange = useContext(SeedingCalendarRangeContext);
  const isInSeedRateRange = isDateInSelectedCropRange(props.day.toDate());

  return (
    <PickerDay
      {...props}
      sx={
        isInSeedRateRange
          ? {
              backgroundColor: '#e8f5e9',
              color: 'success.dark',
              '&:hover, &:focus': { backgroundColor: '#c8e6c9' },
              '&.Mui-selected': { backgroundColor: 'success.dark' },
            }
          : undefined
      }
    />
  );
}
